import { createSlice } from "@reduxjs/toolkit";
import CentersService from "services/CentersService";

const initialState = {
  appsOptions: null,
  businessPackageOptions: null,
};

const optionsAppAndBusinessSlice = createSlice({
  name: "optionsAppAndBusiness",
  initialState,
  reducers: {
    setAppsOptions(state, action) {
      state.appsOptions = action.payload;
    },
    setbusinessPackageOptions(state, action) {
      state.businessPackageOptions = action.payload;
    },
  },
});

export const { setAppsOptions, setbusinessPackageOptions } = optionsAppAndBusinessSlice.actions;

export const initializeAppsOptions = () => {
  return (dispatch) => {
    CentersService.getApps().then((result) => {
      const appsOptions = result.data.map((app) => ({
        ...app,
        name: app.appName,
        value: app.id,
      }));
      dispatch(setAppsOptions(appsOptions))
    })
  }

}

export const initializeBusinessPackageOptions = () => {
  return (dispatch) => {
    CentersService.getPackages().then((result) => {
      const businessPackageOptions = result.data.map((businessPackage) => ({
        ...businessPackage,
        value: businessPackage.id,
      }))
      dispatch(setbusinessPackageOptions(businessPackageOptions))
    })
  }
}

export default optionsAppAndBusinessSlice.reducer;